// require('expose-loader?$!jquery');
// window.jQuery = window.$;
// import 'expose-loader?jQuery!jquery';
// window.$ = window.jQuery;
// import 'expose-loader?$!jquery/jquery.min';
// window.jQuery = window.$;
import 'jquery';
import 'jquery-validation';